import React, { useMemo } from 'react'
import { getMonthlyReport, MonthlyReportRow } from '../../../../utils/requestsUtils/functionsRequests/dashboard/dashboardFunctions'
import * as XLSX from 'xlsx-js-style';
import moment from 'moment';
import InputList from '../../../UIcomponents/InputList/InputList';
import { useTranslation } from 'react-i18next';
import { capitalize } from '../../../../utils/strings/strings';

const Timezone = moment.tz.guess();

type DataExcel = {
    //"Nombre de Gim": string;
    "ID Gim": string;
    "Fecha misi\u00F3n": string;
    "Monto Bruto misi\u00F3n": number;
    "Monto Neto misi\u00F3n": number;
    "Duraci\u00F3n misi\u00F3n": string;
}

const ContainerButtonsMonthlyReports = () => {

    const { t } = useTranslation()

    const getMonthlyDateRanges = () => {
        const start = moment.utc('2024-11-01').tz(Timezone); // Start from November 2024
        const end = moment.utc().tz(Timezone).startOf('month'); // Current month start (e.g., 2025-06-01)

        const result = [];

        const current = start.clone();

        while (current.isSameOrBefore(end)) {
            const startTime = current.clone().startOf('month').toISOString();
            const endTime = current.clone().endOf('month').toISOString();

            result.push({ startTime, endTime });

            current.add(1, 'month');
        }

        return result;
    }

    const dates = useMemo(() => getMonthlyDateRanges(), []);


    const createExcel = (data: DataExcel[], date: string) => {
        // Create a new workbook and worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);
        
        // Define column widths
        worksheet["!cols"] = [
            { wch: 35 }, 
            { wch: 25 }, 
            { wch: 20 }, 

            { wch: 20 }, 
            { wch: 30 }, 

            { wch: 20 }, 
            
            { wch: 20 }, 
            { wch: 30 }, 
            { wch: 20 }, 

            { wch: 20 }, 
        ];
        
        for (const cell in worksheet) {
            if (cell[0] === '!') continue; // skip special properties like !ref, !cols, etc.

            if (!worksheet[cell].s) worksheet[cell].s = {}; // create style object if missing

            worksheet[cell].s.alignment = { horizontal: 'center', vertical: 'center' };
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        
        const documentName = capitalize( moment(date).format("MMMM[_]YYYY") )

        XLSX.writeFile(workbook, `Gimwork_${documentName}.xlsx`);
    };

    const monthlyReport = ({ startTime, endTime }: { startTime: string, endTime: string }) => {
        getMonthlyReport({ startTime, endTime })
        .then(({ rows }: { rows: MonthlyReportRow[] }) => {
            const data = rows.map((row) => {
                return {
                    //["Nombre de Gim"]: `${row.firstName} ${row.lastName}`,
                    ["ID Gim"]: row.id,
                    ["Fecha misión"]: moment(row.startTime).format("D [de] MMMM, YYYY"),
                    ["Monto Bruto misión"]: row.cost,
                    ["Monto Neto misión"]: row.gimProfit,
                    ["Duración misión"]: row.duration 
                }
            })
            createExcel(data, startTime)
        }).catch(() => {

        })
    }

    return (
        <div className="flex flex-ai-center" style={{ zIndex: 3 }}>
            <InputList text={t("General:label_284") ?? ""} width="20rem" height="3rem" >
                {
                    dates.map(({ startTime, endTime }) => { 
                        return (
                            <p 
                                key={startTime}
                                className="pointer p-6 fs-15" 
                                onClick={() => monthlyReport({ startTime, endTime })}
                            >
                                    {capitalize( moment(startTime).format("MMMM, YYYY") )}
                            </p>
                        )
                    })
                }
            </InputList>
        </div>
    )
}

export default React.memo( ContainerButtonsMonthlyReports )